<button class="btn-login"
        id="settingsHeader"
        style="cursor: auto">
    Settings
</button>
<div class="home">
    <div class="games-menu__body">
        <div class="games-menu__body-inner is-active">
            <div class="games-menu__popup">
                <div class="games-popup">
                    <button (click)="goBack()"
                        class="games-popup__close-btn close-btn">
                        <img src="../../../assets/images/games-playground/close-btn.png"
                             title="Close"
                             alt="Close">
                    </button>
                    <div class="games-popup__text">
                        Make sure all of your information is up to date.
                    </div>

                    <div class="phone-info">
                        <div class="phone-info__col">Phone</div>
                        <div class="phone-info__col">{{getPhone() | mask: phoneMask}}</div>
                    </div>

                    <form  [formGroup]="infoForm"
                           (ngSubmit)="onSubmitInfoForm()">
                        <div class="login__item">
                            <input formControlName="first_name"
                                   placeholder="FIRST NAME"
                                   [type]="'text'"
                                   class="games-popup__input"
                                   autocomplete="off">
                        </div>
                        <div class="login__item">
                            <input formControlName="last_name"
                                   placeholder="LAST NAME"
                                   [type]="'text'"
                                   class="games-popup__input"
                                   autocomplete="off">
                        </div>
                        <div class="login__item">
                            <input formControlName="email"
                                   placeholder="EMAIL"
                                   [type]="'text'"
                                   email="true"
                                   class="games-popup__input"
                                   autocomplete="off">
                        </div>
                        <div class="games-popup__row games-popup__row--center" style="margin-top: 1em">
                            <button class="games-btn"
                                    [disabled]="isInfoUpdateBtnDisabled()">
                                <span>Update</span>
                            </button>
                        </div>
                    </form>

                    <div class="settings-form-title">
                        <span>
                           Update password
                        </span>
                    </div>

                    <form  [formGroup]="passwordForm"
                           (ngSubmit)="onSubmitPasswordForm()">
                        <div class="login__item">
                            <input formControlName="oldPassword"
                                   placeholder="OLD PASSWORD"
                                   [type]="'password'"
                                   class="games-popup__input"
                                   autocomplete="off">
                        </div>
                        <div class="login__item">
                            <input formControlName="newPassword"
                                   placeholder="NEW PASSWORD"
                                   [type]="'password'"
                                   class="games-popup__input"
                                   autocomplete="off">
                        </div>
                        <div class="login__item">
                            <input formControlName="reEnteredPassword"
                                   placeholder="RE-ENTER NEW PASSWORD"
                                   [type]="'password'"
                                   class="games-popup__input"
                                   autocomplete="off">
                        </div>
                        <div class="games-popup__row games-popup__row--center" style="margin-top: 1em">
                            <button class="games-btn"
                                    [disabled]="isPasswordUpdateBtnDisabled()">
                                <span>Update</span>
                            </button>
                        </div>
                    </form>

                    <div class="settings-form-title">
                        <span>
                           Update pin
                        </span>
                    </div>

                    <form  [formGroup]="pinForm"
                           (ngSubmit)="onSubmitPinForm()">
                        <div class="login__item">
                            <input formControlName="password"
                                   placeholder="PASSWORD"
                                   [type]="'password'"
                                   class="games-popup__input"
                                   autocomplete="off">
                        </div>
                        <div class="login__items"
                             style="justify-content: flex-start; margin-top: .5em"
                             formArrayName="digits">
                            <input (keydown.enter)="onSubmitPinForm()"
                                   *ngFor="let field of pinForm.get('digits')['controls']; let i = index" #inputs [maxLength]="1" [formControlName]="i"  (keydown)="check(i, field, $event)"
                                   mask="0"
                                   class="login-input-small" type="tel">
                        </div>
                        <div class="games-popup__row games-popup__row--center" style="margin-top: 1em">
                            <button class="games-btn"
                                    [disabled]="isPinUpdateBtnDisabled()">
                                <span>Update</span>
                            </button>
                        </div>
                    </form>
                    <div class="games-info">
<!--                            <span>-->
<!--                                All deposits are final.-->
<!--                            </span>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

